module.exports = __webpack_public_path__ + "img/IMG_6625-Edit.57f937a0.jpg";